import { NgModule, APP_INITIALIZER, isDevMode, ApplicationRef, createComponent, EnvironmentInjector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SawdustDevToolsComponent } from './sawdust-devtools.component';

const initDevTools = (appRef: ApplicationRef, environmentInjector: EnvironmentInjector) => () => {
  // Only initialize in development mode
  if (!isDevMode()) {
    return;
  }

  // Create the DevTools component
  const hostElement = document.createElement('div');
  document.body.appendChild(hostElement);

  const componentRef = createComponent(SawdustDevToolsComponent, {
    environmentInjector,
    hostElement
  });

  // Manually trigger change detection
  componentRef.changeDetectorRef.detectChanges();

  // Attach to the application
  appRef.attachView(componentRef.hostView);
};

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initDevTools,
      deps: [ApplicationRef, EnvironmentInjector],
      multi: true
    }
  ]
})
export class SawdustDevToolsModule {}
